export default {
  setFavProductList(state, list) {
    state.favProductList = list;
  },
  setFavStoreList(state, list) {
    state.favStoreList = list;
  },
  setProductList(state, list) {
    state.product.list = [...state.product.list, ...list];
  },
  setStoreList(state, list) {
    state.store.list = [...state.store.list, ...list];
  },
  resetStoreList(state) {
    state.store.list = [];
    state.store.pageInfo = {
      totalPage: 2
    };
    state.store.page = 1;
  },
  setProductPage(state, page = 1) {
    state.product.page = page;
  },
  setStorePage(state, page = 1) {
    state.store.page = page;
  },
  setProductPageInfo(state, pageInfo) {
    state.product.pageInfo = pageInfo;
  },
  setStorePageInfo(state, pageInfo) {
    state.store.pageInfo = pageInfo;
  },

  initList(state) {
    // state.list = [];
    // state.pageInfo = {};
    // state.page = 1;
    // state.totalPage = 2;
  },

  purge(state) {
    state.product.list = [];
    state.product.pageInfo = {
      totalPage: 2
    };
    state.product.page = 1;

    state.store.list = [];
    state.store.pageInfo = {
      totalPage: 2
    };
    state.store.page = 1;
  }
};
